/**
 * clickGuard — iOS Safari ghost click 차단 전역 가드
 *
 * 사용 시나리오:
 *  - MiniDropdown 옵션 클릭 후 setOpen(false) 시 옵션 list 가 unmount
 *  - touch 종료 후 100~300ms 내 click 이벤트가 그 좌표의 새 element(배너 button)로 전달
 *  - BannerCard 의 onClick 이 트리거되어 의도치 않은 popup 열림
 *
 * 해결:
 *  - 옵션 클릭 직후 markIgnoreUntil(500) 호출 → 500ms 동안 BannerCard click 무시
 */
let _until = 0;
let _installed = false;

export function markIgnoreUntil(ms: number = 800): void {
  _until = Date.now() + ms;
}

export function shouldIgnoreClick(): boolean {
  return Date.now() < _until;
}

/**
 * 요구사항 #286 — document capture 단계에서 모든 click 차단.
 * 어떤 backdrop 도 빠뜨리지 않고 markIgnoreUntil 활성 동안 click 무력화.
 * BannerCard 등 각 컴포넌트의 shouldIgnoreClick 안 호출하는 경우도 cover.
 *
 * App 진입점에서 1회만 호출. ref 가드로 중복 등록 방지.
 */
export function installGlobalClickIgnoreGuard(): void {
  if (_installed || typeof document === "undefined") return;
  _installed = true;
  document.addEventListener(
    "click",
    (e) => {
      if (shouldIgnoreClick()) {
        e.stopPropagation();
        e.preventDefault();
      }
    },
    true, // capture
  );
}
